export const DEFAULT_TAX_RATE = 0.13;
